import { createFileRoute } from '@tanstack/react-router';

import { HiringQuotesPage } from '@/features/hiring/quotes-page';

export const Route = createFileRoute('/_app/projects/$projectId/hiring/quotes/')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <HiringQuotesPage projectId={projectId} />;
}
